import React, { forwardRef } from 'react';

import { TableCell, TableSortLabel, Tooltip } from '@mui/material';

import { classes } from './styles';

import type { SxProps } from '@mui/material';

import type { TPaginationState, TSortableColumn } from './types';

interface ITooltipTableCellProps {
  header: TSortableColumn;
  paginationState: TPaginationState<string>;
  onSortChange: (id: string) => void;
  sx: SxProps;
}

const TooltipTableCell = forwardRef<HTMLTableCellElement, ITooltipTableCellProps>(
  ({ header, paginationState, onSortChange, sx }, ref) => {
    if (!header.enabled) {
      return null;
    }
    const sortActive = paginationState.sort === header.id;
    const sortDirection = sortActive ? (paginationState.sort_order ?? 'asc') : 'asc';

    const tableCell = (
      <TableCell
        ref={ref}
        sortDirection={header.sortable && sortActive ? sortDirection : false}
        sx={sx}
      >
        <TableSortLabel
          active={sortActive}
          direction={sortDirection}
          disabled={!header.sortable}
          id={`${header.id}-sort-label`}
          onClick={() => onSortChange(header.id)}
          sx={header.sortable ? classes.sortable : classes.notSortable}
        >
          {header.label}
        </TableSortLabel>
      </TableCell>
    );

    if (header.tooltip) {
      return (
        <Tooltip key={header.id} arrow title={header.tooltip}>
          {tableCell}
        </Tooltip>
      );
    }

    return tableCell;
  }
);

TooltipTableCell.displayName = 'TooltipTableCell';

export default TooltipTableCell;
